const SignedIn = 'signedIn';
const SignedOut = 'signedOut';
const Loading = 'loading';
const All = [SignedOut, SignedIn, Loading];

export { SignedIn, SignedOut, Loading, All };



// WEBPACK FOOTER //
// ./src/auth/AuthStates.js